// removed by extract-text-webpack-plugin
module.exports = {"shiftsFitersNav":"PiMpONp7vdJyg_dgSkgbl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftsOverview/ShiftsOverview.css
// module id = 253
// module chunks = 0